import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
    ApiCaptchaGetRequest,
    ApiCaptchaGetResponse,
    ApiCaptchaVerifyRequest,
    ApiCaptchaVerifyResponse
} from '@iw-shop/api/captcha';
import {EnvironmentService} from '@iw-shop/core//services/environment.service';
import {AuthenticationService} from "@iw-shop/core/services/authentication.service";
import {setAccessExpire} from "@store/actions/storage.action";
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';

@Injectable({
    providedIn: 'root'
})
export class CaptchaService {

    constructor(private http: HttpClient, private environmentService: EnvironmentService, private authenticationService: AuthenticationService, private store: Store<AppState>) {
    }

    getRandomCaptcha(): Observable<ApiCaptchaGetResponse> {
        const body: ApiCaptchaGetRequest = {id: 'getCaptcha', command: 'captcha/get'};
        return this.http.post<ApiCaptchaGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
    }

    verifyDefault(): Observable<ApiCaptchaVerifyResponse> {
        const body: ApiCaptchaVerifyRequest = {
            id: 'getCaptcha#INVALID_PARAMS',
            command: 'captcha/verify',
            params: {data: {answerId: 'lXvHx', questionId: 'ajWWP'}}
        };
        return this.http.post<ApiCaptchaVerifyResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
    }


    verify(questionId: string, answerId: string): Observable<ApiCaptchaVerifyResponse> {
        const body: ApiCaptchaVerifyRequest = {
            id: 'getCaptcha#INVALID_PARAMS',
            command: 'captcha/verify',
            params: {data: {answerId, questionId}}
        };
        return this.http.post<ApiCaptchaVerifyResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
    }

}
